// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1Tkd1","title":"AfterBackImages_title__PK6WB","images":"AfterBackImages_images__ln3z9"};